module.exports = __webpack_public_path__ + "img/debit-card-pg.fb48acd4.svg";